<template>
  <div class="footer">
    <div>
      <div class="footer-left">
        <span>{{ $t('footer_address') }}</span>
        <span>{{ $t('footer_phone') }}</span>
        <span>info@ray-can.com</span>
      </div>
      <div class="footer-right">
        <span class="clickable" @click="icpClick">{{ $t('footer_icp') }}</span>
        <span>{{ $t('footer_security') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    icpClick() {
      window.open('https://beian.miit.gov.cn/', '_blank')
    }
  }
}
</script>

<style scoped lang="less">
@import '@/assets/styles/views/common.less';
.footer {
  width: 100%;
  min-height: 120px;
  background-color: rgb(77 77 77);
  &>div {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
    
    .footer-left, .footer-right {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-width: 250px;
    }
    
    span {
      font-size: 16px;
      color: #fff;
      margin-bottom: 5px;
      transition: transform 0.3s ease, color 0.3s ease;
      /* cursor: pointer; */
    }
    
    .footer-left span {
      text-align: left;
    }
    
    .footer-right span {
      text-align: right;
    }
    
    span:hover {
      transform: scale(1.05);
      color: white;
    }

    .footer-right .clickable {
      cursor: pointer;
      &:active {
        transform: scale(0.98);
        color: rgba(255, 255, 255, 0.8);
      }
    }
    
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      text-align: center;
      
      .footer-left span,
      .footer-right span {
        text-align: center;
      }
    }
  }
}
</style>
